import { doc, onSnapshot } from 'firebase/firestore';
import { ObjectiveStateResourceType } from '.';
import { thisOscarsYear } from '../../config/constants';
import { database } from '../../config/firebase';
import { queueUpdate } from '../../util/spoilerDelayBuffer';

let watchObjectiveState = () =>
  onSnapshot(doc(database, 'objective_state', String(thisOscarsYear)), doc => {
    if (doc.metadata.hasPendingWrites) return;

    let data = doc.data() as Partial<ObjectiveStateResourceType>;

    queueUpdate('objectiveState', data);
  });

export default watchObjectiveState;
